import { React } from "react";

import { useTranslation } from 'react-i18next';

const CabeceraAyuda = ({ruta, textopol}) => {
    const { t } = useTranslation();

	var imagen = "/images/web/bedloop-nofoto.png"; 

	if (textopol.imagen_cabecera)
	{
		imagen = ruta+"/"+textopol.imagen_cabecera;
	}

    return (
        <>
			<div className="imatge-banner" title={ t("Ayuda") } style={{  backgroundImage: "url('"+imagen+"')", backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundSize: "cover"}} >
            </div>
		</>
    );
}

export default CabeceraAyuda;




				